(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6749caffeb6855964a075aa2";
              window.beaePageSetting.pageTitle = "Product page Little Pure Kids price description buy"; 
              window.beaePageSetting.pageType = "product";

          let js_KCG8N694 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-mpxbgt4vsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mpxbgt4v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mpxbgt4v');
        args.el = args.els[0];
        ((data) => { data.el.querySelector(".beae-grid-system")?.addEventListener("scroll", (e) => {
    let el = e.target;
    if (!el.classList.contains("beae-grid-carousel")) {
      return;
    }
    let activePage = Math.round((el.scrollLeft + el.querySelector(".beae-grid-carousel__snaps").offsetLeft) / (el.offsetWidth * 0.8)) + 1;
    data.el.querySelector(".beae-grid-carousel__pagination div.active")?.classList.remove("active");
    data.el.querySelector('.beae-grid-carousel__pagination div[data-index="' + activePage + '"]')?.classList.add("active");
  });
  if (data.mode.value == "live") {
    const videoContainer = data.el.querySelector('.beae-section-background-video[data-device="desktop"]');
    const videoMobileContainer = data.el.querySelector('.beae-section-background-video[data-device="mobile"]');
    const initVideoBackground = [];
    if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
      if (window.innerWidth >= 768) {
        if (videoContainer) {
          let options = {};
          if (data.optionsVideo) {
            try {
              eval(`options = ` + data.optionsVideo);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoContainer);
          if (rs) {
            videoContainer.innerHTML = rs.html;
            initVideoBackground.push("desktop");
          }
        }
      } else {
        if (videoMobileContainer) {
          let options = {};
          if (data.optionsVideoMobile) {
            try {
              eval(`options = ` + data.optionsVideoMobile);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoMobileContainer);
          if (rs) {
            videoMobileContainer.innerHTML = rs.html;
            initVideoBackground.push("mobile");
          }
        }
      }
    }
    if (videoContainer || videoMobileContainer) {
      window.addEventListener("resize", () => {
        if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
          if (!initVideoBackground.includes("desktop") && window.innerWidth >= 768 && videoContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo, videoContainer);
            if (rs2) {
              videoContainer.innerHTML = rs2.html;
              initVideoBackground.push("desktop");
            }
          }
          if (!initVideoBackground.includes("mobile") && window.innerWidth < 768 && videoMobileContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile, videoMobileContainer);
            if (rs2) {
              videoMobileContainer.innerHTML = rs2.html;
              initVideoBackground.push("mobile");
            }
          }
        }
      });
    }
  }
  data.el.querySelectorAll(".beae-text-highlight").forEach((element) => {
    let observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll("path, line").forEach((path) => {
            path.style.strokeDasharray = parseFloat(path.getAttribute("data-dash-ratio") * entry.target.offsetWidth * 2) + "px, 999999px";
          });
          observer2.unobserve(entry.target);
        }
      });
    }, { root: document, rootMargin: "0px 0px -40%" });
    observer.observe(element);
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mpxbgt4v: ', ex)
      };
    

      try {
        let argid = 'beae-mpxbgt4vsection-featured-product',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mpxbgt4v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mpxbgt4v');
        args.el = args.els[0];
        ((data) => { const productWrp = data.el.querySelector('script[data-id="Product-json-' + data.id + '"]') || data.el.querySelector("#Product-json-" + data.id);
  let variantChange = false;
  const product = JSON.parse(productWrp?.innerHTML ? productWrp?.innerHTML : "{}");
  let selectedVariant = product?.selected_or_first_available_variant ? product?.selected_or_first_available_variant : product.variants?.[0];
  if (!window.BeaeMoneyFormat) {
    window.BeaeMoneyFormat = data.el.querySelector(".beae-money-format")?.innerHTML;
  }
  if (selectedVariant) {
    selectedVariant = product.variants.find((variant) => variant.id == selectedVariant.id);
  }
  updateInventory(selectedVariant);
  function updatePrice(variant) {
    const priceDoms = data.el.querySelectorAll(".beae-product-single__price");
    priceDoms && priceDoms.forEach((priceDom) => {
      if (priceDom) {
        let price = window.BeaeFormatMoney(variant.price);
        if (price && typeof price == "string") {
          price = price.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        }
        priceDom.innerHTML = price;
      }
    });
    const compareAtPriceDoms = data.el.querySelectorAll(".beae-product-single__price--regular");
    compareAtPriceDoms && compareAtPriceDoms.forEach((compareAtPriceDom) => {
      if (compareAtPriceDom) {
        if (variant.compare_at_price) {
          compareAtPriceDom.style.display = "block";
          let compareAtPrice = window.BeaeFormatMoney(variant.compare_at_price);
          if (compareAtPrice && typeof compareAtPrice == "string") {
            compareAtPrice = compareAtPrice.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
          }
          compareAtPriceDom.innerHTML = compareAtPrice;
        } else {
          compareAtPriceDom.style.display = "none";
        }
      }
    });
  }
  function updateBagedPrice(variant) {
    const baggedPris = data.el.querySelectorAll(".beae-product-single__price--badged");
    const price = parseFloat(variant.price?.toString()?.replace(",", ""));
    const compareAtPrice = parseFloat(variant.compare_at_price?.toString()?.replace(",", ""));
    baggedPris && baggedPris.forEach((baggedPri) => {
      if (!baggedPri) {
        return;
      }
      const type = baggedPri.getAttribute("type");
      const saleText = baggedPri.getAttribute("data-sale") || "";
      const soldOutText = baggedPri.getAttribute("data-sold-out");
      let a = "";
      if (type == "percent") {
        a = Math.floor((compareAtPrice - price) * 100 / compareAtPrice);
      } else if (type == "dollar") {
        const minus = window.BeaeFormatDecimal(variant.compare_at_price) - window.BeaeFormatDecimal(variant.price);
        a = window.BeaeFormatMoney(window.BeaeReverseFormatDecimal(minus));
      } else if (type == "none") {
        baggedPri.classList.remove("beae-product-single__price--sale", "beae-sale-sold-out");
        baggedPri.classList.add("beae-sale-hidden");
        baggedPri.innerHTML = "";
        return;
      }
      const inventory_quantity = variant.inventory_quantity;
      const policy = variant.inventory_policy;
      if (inventory_quantity > 0 || inventory_quantity < 1 && policy == "continue" || !variant.inventory_management) {
        if (compareAtPrice && compareAtPrice > price) {
          baggedPri.classList.remove("beae-sale-sold-out", "beae-sale-hidden");
          baggedPri.classList.add("beae-product-single__price--sale");
          let textsale = saleText.replace(new RegExp(`{\\s*?sale\\s*?}`, "g"), a);
          if (textsale) {
            textsale = textsale.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
          }
          baggedPri.innerHTML = textsale;
        } else {
          baggedPri.classList.remove("beae-product-single__price--sale", "beae-sale-sold-out");
          baggedPri.classList.add("beae-sale-hidden");
          baggedPri.innerHTML = "";
        }
      } else {
        baggedPri.classList.remove("beae-sale-hidden", "beae-product-single__price--sale");
        baggedPri.classList.add("beae-sale-sold-out");
        baggedPri.innerHTML = soldOutText;
      }
    });
  }
  function updateBadged(variant) {
    const price = parseFloat(variant.price?.toString()?.replace(",", ""));
    const compareAtPrice = parseFloat(variant.compare_at_price?.toString()?.replace(",", ""));
    let baggedPris = data.el.querySelectorAll(".beae-badged-wrapper span");
    if (baggedPris) {
      baggedPris.forEach((baggedPri) => {
        if (!baggedPri) {
          return;
        }
        const type = baggedPri.getAttribute("type");
        const saleText = baggedPri.getAttribute("data-sale") || "";
        const soldOutText = baggedPri.getAttribute("data-sold-out");
        let a = "";
        if (type == "percent") {
          a = Math.floor((compareAtPrice - price) * 100 / compareAtPrice);
        } else if (type == "dollar") {
          const minus = window.BeaeFormatDecimal(variant.compare_at_price) - window.BeaeFormatDecimal(variant.price);
          a = window.BeaeFormatMoney(window.BeaeReverseFormatDecimal(minus));
        } else if (type == "none") {
          baggedPri.classList.remove("beae-product-single__price--sale", "beae-sale-sold-out");
          baggedPri.classList.add("beae-sale-hidden");
          baggedPri.innerHTML = "";
          return;
        }
        const inventory_quantity = variant.inventory_quantity;
        const policy = variant.inventory_policy;
        if (inventory_quantity > 0 || inventory_quantity < 1 && policy == "continue" || !variant.inventory_management) {
          const price2 = parseFloat(variant.price);
          const compareAtPrice2 = parseFloat(variant.compare_at_price);
          if (compareAtPrice2 && compareAtPrice2 > price2) {
            baggedPri.classList.remove("beae-sale-sold-out", "beae-sale-hidden");
            baggedPri.classList.add("beae-product-single__price--sale");
            let textsale = saleText.replace(new RegExp(`{\\s*?sale\\s*?}`, "g"), a);
            if (textsale) {
              textsale = textsale.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
            }
            baggedPri.innerHTML = textsale;
          } else {
            baggedPri.classList.remove("beae-product-single__price--sale", "beae-sale-sold-out");
            baggedPri.classList.add("beae-sale-hidden");
            baggedPri.innerHTML = "";
          }
        } else {
          baggedPri.classList.remove("beae-sale-hidden", "beae-product-single__price--sale");
          baggedPri.classList.add("beae-sale-sold-out");
          baggedPri.innerHTML = soldOutText;
        }
      });
    }
  }
  function updateImageSlider(variant) {
    const productMediaWrps = data.el.querySelectorAll(
      ".beae-x-product-gallery .beae-slider"
    );
    if (productMediaWrps && product && variant.featured_media) {
      productMediaWrps.forEach((element) => {
        const desktopLayout = element.getAttribute("data-desktop-layout");
        if (window.innerWidth >= 768 && desktopLayout == "grid") {
          const itemCenter = element.querySelector('.beae-slide-item[data-media-id="' + variant.featured_media.id + '"]');
          const activeItems = Array.from(
            element.querySelectorAll(".beae-slide-item.beae-grid-active")
          ).filter(function(node) {
            return node.nodeType === 1 && node !== itemCenter;
          });
          activeItems.forEach((activeItem) => {
            activeItem.classList.remove("beae-grid-active");
          });
          itemCenter.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
          if (itemCenter && !itemCenter.classList.contains("beae-grid-active")) {
            itemCenter.classList.add("beae-grid-active");
          }
        } else {
          element.dispatchEvent(
            new CustomEvent("activeSlide", {
              detail: {
                id: variant.featured_media.id
              },
              bubbles: true,
              cancelable: true,
              composed: false
            })
          );
        }
      });
    }
  }
  function updateInventory(variant) {
    const inventoryWrp = data.el.querySelector(".beae-x-inventory");
    if (!inventoryWrp || !variant)
      return;
    const inventoryElement = inventoryWrp.children[0];
    const inStockText = inventoryWrp.getAttribute("data-in-stock-text");
    const outStockText = inventoryWrp.getAttribute("data-out-stock-text");
    const inventoryText = inventoryWrp.getAttribute("data-inventory-text");
    const preOrderText = inventoryWrp.getAttribute("data-pre-order-text");
    const veryLowText = inventoryWrp.getAttribute("data-very-low-stock-text");
    const lowText = inventoryWrp.getAttribute("data-low-stock-text");
    const incomingDateText = inventoryWrp.getAttribute("data-incoming-date-text");
    const lowNumber = inventoryWrp.getAttribute("data-low-number") ?? 20;
    const veryLowNumber = inventoryWrp.getAttribute("data-very-low-number") ?? 5;
    const showNextIncomingDate = inventoryWrp.getAttribute("data-show-next-incoming-date");
    const maxNumber = inventoryWrp.getAttribute("data-max-number") ?? 60;
    const inventoryLabel = inventoryWrp.querySelector(".beae-inventory-label");
    const process = inventoryWrp.querySelector(".beae-inventory-process-body");
    let quantity = variant.inventory_quantity;
    const hasVariant = data.el.querySelector(".beae-x-variant") || data.el.querySelector(".beae-x-swatch-color") || data.el.querySelector(".beae-x-add-to-cart-with-option");
    if (!hasVariant) {
      quantity = product.variants.reduce((sum, item) => sum + (item.inventory_quantity || 0), 0);
    }
    function replaceText(text) {
      if (!text)
        return "";
      return text.replace("{quantity}", quantity).replace("{next_incoming_date}", variant.next_incoming_date);
    }
    if (!inventoryElement || !inventoryLabel)
      return;
    if (!variant.available) {
      if (variant.next_incoming_date && showNextIncomingDate) {
        inventoryLabel.innerHTML = replaceText(incomingDateText);
        inventoryElement.classList = "";
        inventoryElement.classList.add("beae-incoming-transfer");
      } else {
        inventoryLabel.innerHTML = replaceText(outStockText);
        inventoryElement.classList = "";
        inventoryElement.classList.add("beae-inventory-out-stock");
      }
    } else {
      if (variant.inventory_policy === "continue" && quantity < 1) {
        inventoryLabel.innerHTML = replaceText(preOrderText);
        inventoryElement.classList = "";
        inventoryElement.classList.add("beae-inventory-pre-order");
      } else {
        if (quantity <= veryLowNumber) {
          inventoryLabel.innerHTML = replaceText(veryLowText);
          inventoryElement.classList = "";
          inventoryElement.classList.add("beae-inventory-very-low");
        } else if (quantity <= lowNumber) {
          inventoryLabel.innerHTML = replaceText(lowText);
          inventoryElement.classList = "";
          inventoryElement.classList.add("beae-inventory-low");
        } else {
          inventoryLabel.innerHTML = replaceText(inStockText);
          inventoryElement.classList = "";
          inventoryElement.classList.add("beae-inventory-in-stock");
        }
      }
    }
    if (process) {
      if (quantity <= maxNumber) {
        process.style.width = quantity / maxNumber * 100 + "%";
      } else {
        process.style.width = "100%";
      }
    }
  }
  function updateBuyButton(variant) {
    const addToCartWrp = data.el.querySelector(".beae-add-to-cart--submit");
    if (addToCartWrp) {
      const content = addToCartWrp.querySelector(".beae-add-to-cart-text-content");
      if (variant.available) {
        if (addToCartWrp) {
          addToCartWrp.removeAttribute("disabled");
          if (content) {
            content.innerHTML = addToCartWrp.getAttribute(
              "data-add-to-cart-text"
            );
          }
        }
      } else {
        if (addToCartWrp) {
          if (data.mode.value == "live") {
            addToCartWrp.setAttribute("disabled", "disabled");
          }
          if (content) {
            content.innerHTML = addToCartWrp.getAttribute(
              "data-sold-out-text"
            );
          }
        }
      }
    }
    const checkoutBtn = data.el.querySelector(".shopify-payment-button__button");
    if (checkoutBtn) {
      if (variant.inventory_quantity > 0) {
        checkoutBtn.removeAttribute("disabled");
      } else {
        if (data.mode.value == "live") {
          checkoutBtn.setAttribute("disabled", "disabled");
        }
      }
    }
  }
  function updateQuantity(variant) {
    const $quantity = data.el.querySelector(".beae-quantity-input"), $btn_quantity = data.el.querySelectorAll(".beae-quantity-btn");
    if ($btn_quantity) {
      $btn_quantity.forEach((x) => {
        if (!variant) {
          if (data.mode.value == "live") {
            x.setAttribute("disabled", "disabled");
          }
        } else if (!variant.available) {
          if (data.mode.value == "live") {
            x.setAttribute("disabled", "disabled");
          }
        } else {
          x.removeAttribute("disabled");
        }
      });
    }
    if ($quantity) {
      if (!variant) {
        $quantity.value = 1;
        if (data.mode.value == "live") {
          $quantity.setAttribute("disabled", "disabled");
        }
        return;
      } else if (!variant.available) {
        if (data.mode.value == "live") {
          $quantity.setAttribute("disabled", "disabled");
        }
      } else {
        $quantity.removeAttribute("disabled");
      }
      const inventory_quantity = variant.inventory_quantity;
      const policy = variant.inventory_policy;
      let max = 9999;
      if (variant.inventory_management && policy === "deny") {
        max = inventory_quantity;
      }
      if (inventory_quantity < 1 && policy == "continue") {
        max = 999999;
      }
      let quantity = parseInt($quantity.value);
      if (quantity > max) {
        quantity = max;
      }
      quantity = isNaN(quantity) || !quantity ? 1 : quantity;
      $quantity.value = quantity;
      $quantity.setAttribute("max", max);
    }
  }
  function updateLocalPickup(variant) {
    if (variant) {
      let localPickUpWrp = data.el.querySelector(".beae-pa-container");
      if (localPickUpWrp) {
        if (data.mode.value == "live") {
          const sectionIdTemplate = localPickUpWrp.getAttribute("data-section-id-template");
          localPickUpWrp.innerHTML = "";
          window.fetch(
            window.location.origin + "/variants/" + variant.id + "/?section_id=" + sectionIdTemplate,
            {
              method: "GET",
              headers: {
                "Content-Type": "text/html"
              }
            }
          ).then((response) => response.text()).then((text) => {
            let html = text.match(/<Beae-custom-liquid-pickup>(|[\s\S]+?)<\/Beae-custom-liquid-pickup>/g);
            if (html && html[0]) {
              localPickUpWrp.innerHTML = html[0];
            }
            let btnPopup = localPickUpWrp.querySelector(".beae-pa--btn"), contentPopup = localPickUpWrp.querySelector(".beae-pa--detail");
            if (btnPopup) {
              const section = localPickUpWrp.closest("section.beae-section");
              let sectionId = "";
              if (section) {
                sectionId = section.getAttribute("data-sectionid");
              }
              btnPopup.addEventListener("click", () => {
                window.BeaePopupLibrary.createPopup(contentPopup, {
                  layout: localPickUpWrp.getAttribute("data-layout"),
                  layoutMobile: "bottom",
                  width: localPickUpWrp.getAttribute("data-width"),
                  id: data.id
                });
              });
            }
          }).catch((err) => {
            console.warn(err.message);
          });
        }
      }
    }
  }
  const sizeGuideWrp = data.el.querySelector(".beae-variant-size-guide");
  if (sizeGuideWrp) {
    const sizeGuideBtn = sizeGuideWrp.querySelector(
      ".beae-variant-size-guide-btn"
    );
    const sizeGuideContent = sizeGuideWrp.querySelector(".beae-variant-size-guide-content");
    const sizeGuideContentPreview = data.el.querySelector(".beae-content-size-chart-preview");
    let content = window.isPreviewTemplate ? sizeGuideContentPreview ? sizeGuideContentPreview : sizeGuideContent : sizeGuideContent;
    if (sizeGuideBtn && content) {
      const sectionId = data.el.getAttribute("data-sectionid");
      sizeGuideBtn.addEventListener("click", () => {
        if (window?.BeaePopupLibrary) {
          window.BeaePopupLibrary.createPopup(content, {
            layout: "center",
            layoutMobile: "bottom",
            width: "auto",
            sectionId
          });
        }
      });
    }
  }
  const dropdownSelected = data.el.querySelectorAll(".beae-custom-select_wrp");
  if (dropdownSelected && dropdownSelected.length && data.mode.value == "live") {
    dropdownSelected.forEach((selectWrp) => {
      const dropdownSelectedBtn = selectWrp.querySelector("button.beae-custom-select__btn");
      const wrpDropdown = selectWrp.closest("div.beae-block.beae-core");
      dropdownSelectedBtn.addEventListener("click", function(event) {
        selectWrp.classList.toggle("active");
        wrpDropdown.style.position = "relative";
        wrpDropdown.style.zIndex = "1";
      });
      document.addEventListener("click", function(event) {
        if (!selectWrp.contains(event.target)) {
          selectWrp.classList.remove("active");
          wrpDropdown.style = {};
        }
      });
    });
  }
  function closeSelectedActive() {
    const activeSelected = data.el.querySelector(".beae-custom-select_wrp.active");
    if (activeSelected) {
      activeSelected.classList.remove("active");
    }
  }
  const variantBlock = data.el.querySelector(".beae-x-variant");
  let isInit = false;
  if (variantBlock) {
    let findVariantsByOptions = function(variant, option) {
      if (!variant) {
        return [];
      }
      let optionsValue = variant.options.filter(
        (item, index) => index != option
      );
      return product.variants.filter((v) => {
        return optionsValue.every((item) => {
          return v.options.includes(item);
        });
      }) ?? [];
    }, findVariantByOptionAndValue = function(variant, option, value) {
      if (!variant) {
        return null;
      }
      let optionsValue = variant.options.filter(
        (item, index) => index != option
      );
      return product.variants.find((v) => {
        return v.options.every((o) => [value, ...optionsValue].includes(o));
      });
    }, updateVariant = function(variant) {
      if (!variant)
        return;
      const form = data.el.querySelector("form.beae-product-form-next");
      if (form) {
        form.getAttribute("data-variant-id", variant.id);
        const inputId = form.querySelector('input[type="hidden"][name="id"]');
        if (inputId) {
          inputId.setAttribute("value", variant.id);
        }
      }
      variantBlock.querySelectorAll(".beae-variant-label").forEach((label) => {
        const optionPosition = parseInt(label.getAttribute("data-option-position")) - 1;
        label.innerHTML = variant.options[optionPosition];
      });
      if (!selectImg) {
        variantBlock.querySelectorAll(".beae-product-images-list").forEach((swatch) => {
          const optionPosition = parseInt(swatch.getAttribute("data-option-position")) - 1;
          let swatchContent = [];
          findVariantsByOptions(variant, optionPosition).forEach((v) => {
            swatchContent.push(`
                  <span
                    class="beae-product-swatch-item-image"
                    variant-id=${v.id}
                  >
                    <img
                      src="${v.featured_image ? v.featured_image.src : "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-160-1cfae84eca4ba66892099dcd26e604f5801fdadb3693bc9977f476aa160931ac_120x120_crop_center.gif"}"
                      alt="${v.title}"
                      height="120"
                      width="120"
                      loading="lazy"
                    />
                  </span>
                `);
          });
          swatch.querySelectorAll(".beae-product-variant-item-image").forEach((item, index) => {
            item.innerHTML = swatchContent[index];
          });
        });
      }
      variantBlock.querySelectorAll(".beae-product-variant-item").forEach((swatch) => {
        const optionPosition = parseInt(swatch.getAttribute("data-option-position")) - 1;
        const optionValue = swatch.getAttribute("data-value") ? decodeURIComponent(swatch.getAttribute("data-value")) : "";
        const v = findVariantByOptionAndValue(variant, optionPosition, optionValue);
        if (v) {
          swatch.setAttribute("data-variant-id", v.id);
          if (!v.inventory_management) {
            swatch.classList.remove("variant-item-disable");
          } else {
            if (v.inventory_quantity < 1 && v.inventory_policy != "continue") {
              swatch.classList.add("variant-item-disable");
            } else {
              swatch.classList.remove("variant-item-disable");
            }
          }
        }
      });
    }, handleSwatchActive = function(variant) {
      variant.options.forEach((option, index) => {
        let position = index + 1;
        const list = variantBlock.querySelectorAll('.beae-variant-option-list[data-option-position="' + position + '"] > li');
        let current = null;
        const select = variantBlock.querySelector(
          "select#" + selectorId + "-option-" + index
        );
        if (select) {
          for (let i = 0; i < list.length; i++) {
            list[i].classList.remove("beae-product-variant-item--selected");
            if (decodeURIComponent(list[i].getAttribute("data-value")) == option) {
              current = list[i];
            }
          }
          current && current.classList.add("beae-product-variant-item--selected");
          select.value = option;
        }
        const wrpCustomSelect = current && current.closest(".beae-custom-select_wrp");
        if (wrpCustomSelect) {
          const color = current && current.getAttribute("data-color");
          const colorSelected = wrpCustomSelect.querySelector(".beae-selected-color");
          if (colorSelected) {
            colorSelected.style = "--beae-color-variant: " + color;
          }
          const textSelected = wrpCustomSelect.querySelector(".beae-text-selected");
          if (textSelected) {
            textSelected.innerHTML = option;
          }
        }
      });
    }, selectCallback = function(variant, selector2) {
      handleVariant(variant);
      if (!variant) {
        return;
      }
      variantChange = true;
      selectedVariant = variant;
      updateInventory(variant);
      updateQuantity(variant);
      updateBuyButton(variant);
      updateBagedPrice(variant);
      updateBadged(variant);
      updateVariant(variant);
      updatePrice(variant);
      if (firstLoad) {
        firstLoad = false;
        if (!window.noUpdateImageFirstLoad) {
          setTimeout(() => {
            updateImageSlider(variant);
          });
        }
      } else {
        updateImageSlider(variant);
      }
      updateLocalPickup(variant);
      data.el.dispatchEvent(
        new CustomEvent("changeVariant", {
          detail: {
            variant
          },
          bubbles: true,
          cancelable: true,
          composed: false
        })
      );
    }, handleSwatchImage = function() {
      const isSwatchImage = data.el.querySelector('.beae-product-option-cont[data-swatch-type="variant_image"]');
      if (!isSwatchImage) {
        return;
      }
      const indexActive = isSwatchImage.getAttribute("data-option-position");
      const noImageSrc = "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-160-1cfae84eca4ba66892099dcd26e604f5801fdadb3693bc9977f476aa160931ac_120x120_crop_center.gif";
      const otherOptions = data.el.querySelectorAll('.beae-product-option-cont:not([data-swatch-type="variant_image"])');
      const otherValue = {};
      if (otherOptions && otherOptions.length) {
        otherOptions.forEach((option) => {
          const activeValue = option.querySelector(".beae-product-variant-item--selected");
          if (!activeValue) {
            return;
          }
          const position = activeValue.getAttribute("data-option-position");
          const value = decodeURIComponent(activeValue.getAttribute("data-value"));
          otherValue["option" + position] = value;
        });
      }
      const variantMatch = product.variants.filter((x) => {
        return Object.keys(otherValue).every((key) => {
          return otherValue[key] == x[key];
        });
      });
      const items = isSwatchImage.querySelectorAll(".beae-product-variant-item");
      if (items && items.length) {
        items.forEach((item) => {
          const value = decodeURIComponent(item.getAttribute("data-value"));
          const variant = variantMatch.find((x) => x["option" + indexActive] == value);
          if (!item.querySelector("img")) {
            item.innerHTML = `
                            <span class="beae-product-swatch-item-image">
                            <img
                            src="${variant && variant.featured_image ? variant.featured_image.src : noImageSrc}"
                            alt="${variant && variant.title}"
                            height="100"
                            width="100"
                            loading="lazy"
                            />
                        </span>
                        `;
          }
          ;
        });
      }
    }, handleVariant = function(variant) {
      let vairantMatch = product.variants;
      let option1 = variant && variant.option1;
      let option2 = variant && variant.option2;
      if (!variant) {
        const activeOption1 = data.el.querySelector('.beae-variant-option-list[data-option-position="1"] .beae-product-variant-item--selected');
        if (activeOption1) {
          option1 = decodeURIComponent(activeOption1.getAttribute("data-value"));
        }
        const activeOption2 = data.el.querySelector('.beae-variant-option-list[data-option-position="2"] .beae-product-variant-item--selected');
        if (activeOption2) {
          option2 = decodeURIComponent(activeOption2.getAttribute("data-value"));
        }
      }
      let options2 = [];
      let options3 = [];
      if (option1) {
        vairantMatch = product.variants.filter((x) => x.option1 == option1);
        vairantMatch.forEach((x) => {
          if (x.option2 && !options2?.includes(x.option2)) {
            options2.push(x.option2);
          }
        });
        vairantMatch.forEach((x) => {
          if (x.option2 == option2 && x.option3 && !options3?.includes(x.option3)) {
            options3.push(x.option3);
          }
        });
      }
      [2, 3].forEach((num) => {
        const listOption = data.el.querySelectorAll('.beae-variant-option-list[data-option-position="' + num + '"] .beae-product-variant-item');
        if (listOption) {
          let keyOption = num == 2 ? options2 : options3;
          listOption.forEach((x) => {
            const value = decodeURIComponent(x.getAttribute("data-value"));
            if (keyOption.includes(value)) {
              x.setAttribute("data-unavailable", false);
            } else {
              x.setAttribute("data-unavailable", true);
            }
          });
        }
      });
      if (!variant) {
        if (options2 && options2.length) {
          const active2 = data.el.querySelector('.beae-variant-option-list[data-option-position="2"] .beae-product-variant-item--selected[data-unavailable="false"]');
          const firstOption2 = data.el.querySelector('.beae-variant-option-list[data-option-position="2"] .beae-product-variant-item[data-unavailable="false"]');
          if (!active2 && firstOption2) {
            firstOption2.click();
          }
        }
        if (options3 && options3.length) {
          const active3 = data.el.querySelector('.beae-variant-option-list[data-option-position="3"] .beae-product-variant-item--selected[data-unavailable="false"]');
          const firstOption3 = data.el.querySelector('.beae-variant-option-list[data-option-position="3"] .beae-product-variant-item[data-unavailable="false"]');
          if (firstOption3) {
            firstOption3.click();
          }
        }
      }
      handleSwatchImage();
    };
    let firstLoad = true, selectImg = false, selector = variantBlock.querySelector('select[name="id"]');
    let firstActiveVariant = true;
    data.el.addEventListener("activeVariant", function(e) {
      if (firstActiveVariant) {
        firstActiveVariant = false;
        return;
      }
      if (variantChange) {
        variantChange = false;
        return;
      }
      if (!product.variants || !e.detail.id || selectedVariant && selectedVariant.featured_media && e.detail.id == selectedVariant.featured_media.id) {
        return;
      }
      const variant = product.variants.find((x) => {
        if (!x || !x.featured_media || !x.featured_media.id || !e.detail.id)
          return false;
        return x.featured_media.id == e.detail.id;
      });
      if (!variant || selectedVariant.id == variant.id)
        return;
      handleSwatchActive(variant);
      handleVariant(variant);
      selectedVariant = variant;
      updateInventory(variant);
      updateQuantity(variant);
      updateBuyButton(variant);
      updateVariant(variant);
      updatePrice(variant);
      updateBagedPrice(variant);
      updateBadged(variant);
      updateLocalPickup(variant);
    });
    const selectorId = selector && selector.getAttribute("id");
    if (selector && window.Shopify && window.Shopify.OptionSelectors) {
      let handleSelectedVariant = function(swatch) {
        firstLoad = false;
        const index = parseInt(swatch.getAttribute("data-option-position")) - 1;
        const select = variantBlock.querySelector(
          "select#" + selectorId + "-option-" + index
        );
        const value = decodeURIComponent(swatch.getAttribute("data-value") ?? swatch.value);
        if (select) {
          const siblings = swatch.parentElement?.children ?? [];
          for (let i = 0; i < siblings.length; i++) {
            siblings[i].classList.remove("beae-product-variant-item--selected");
          }
          swatch.classList.add("beae-product-variant-item--selected");
          select.value = value;
          select.onchange();
        }
        const wrpCustomSelect = swatch.closest(".beae-custom-select_wrp");
        if (wrpCustomSelect) {
          const color = swatch.getAttribute("data-color");
          const colorSelected = wrpCustomSelect.querySelector(".beae-selected-color");
          if (colorSelected) {
            colorSelected.style = "--beae-color-variant: " + color;
          }
          const textSelected = wrpCustomSelect.querySelector(".beae-text-selected");
          if (textSelected) {
            textSelected.innerHTML = value;
          }
        }
      };
      const mySelector = new window.Shopify.OptionSelectors(selectorId, {
        product,
        onVariantSelected: selectCallback,
        enableHistoryState: data.mode.value == "live" ? !data.el.closest(".beae-next-popup") ? true : false : false
      });
      variantBlock.querySelectorAll(".beae-product-variant-item").forEach((swatch) => {
        swatch.addEventListener("click", function(e) {
          selectImg = false;
          handleSelectedVariant(swatch);
          closeSelectedActive();
        });
      });
      variantBlock.querySelectorAll(".beae-product-variant-item-image").forEach((swatch) => {
        swatch.addEventListener("click", function(e) {
          selectImg = true;
          handleSelectedVariant(swatch);
        });
      });
    }
  } else {
    isInit = true;
  }
  if (product.has_only_default_variant) {
    isInit = true;
  }
  if (isInit) {
    initValueProduct();
  }
  function initValueProduct() {
    if (selectedVariant) {
      if (selectedVariant?.title == "Default Title") {
        selectedVariant = product.variants[0];
      }
      updateInventory(selectedVariant);
      updateQuantity(selectedVariant);
      updateBuyButton(selectedVariant);
      updateBagedPrice(selectedVariant);
      updateBadged(selectedVariant);
    }
  } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mpxbgt4v: ', ex)
      };
    

      try {
        let argid = 'beae-ns1sv0d4block-gallery',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ns1sv0d4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ns1sv0d4');
        args.el = args.els[0];
        ((data) => { setTimeout(() => {
    if (!data.el.querySelector("button.beae-media-zoom")) {
      return;
    }
    data.el.querySelectorAll("button.beae-media-zoom").forEach((zoomButton) => zoomButton.addEventListener("click", (e) => {
      if (data.mode.value === "builder") {
      }
      if (zoomButton.closest(".beae-slider-items")) {
        data.el.querySelectorAll(".beae-slider-items>*.active").forEach((slide) => slide.classList.remove("active"));
        zoomButton.parentNode.classList.add("active");
      }
      let zoomWrp = document.createElement("div"), slides = data.el.querySelectorAll("div.beae-slider-items > *"), slidesContent = data.el.querySelector("div.beae-slider-content").getBoundingClientRect();
      zoomWrp.setAttribute("class", `beae-sections beae-content-wrapper`);
      zoomWrp.innerHTML = `
        <div class="${data.id}">
          <div class="beae-gallery-zoom">
            <div class="beae-gallery-zoom-content" style="transform-origin: ${slidesContent.left}px ${slidesContent.top + slidesContent.height / 2}px;">
              <div class="beae-gallery-zoom-items">
                ${Array.from(slides).map((slide, i) => {
        const type = slide.getAttribute("type");
        if (!type || type?.toLowerCase() != "image") {
          return "";
        }
        return `
                    <div class="beae-gallery-zoom-item${slide.classList.contains("active") ? " active" : ""}" style="${slide.classList.contains("active") ? "order: -1;" : ""}">
                      ${slide.innerHTML}
                    </div>
                  `;
      }).join("")}
              </div>
            </div>
            <div class="beae-gallery-zoom-controls">
              <div class="beae-gallery-zoom-pagination">
                <button class="pagination_item prev">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                  </svg>
                </button>
                <span class="pagination_item per">0 / 0</span>
                <button class="pagination_item next">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                  </svg>
                </button>
              </div>
            </div>
            <button class="beae-gallery-zoom-close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
              </svg>
            </button>
          </div>
        </div>
      `;
      document.body.appendChild(zoomWrp);
      document.body.style.overflow = "hidden";
      let closeBtn = zoomWrp.querySelector("button.beae-gallery-zoom-close"), zoomMain = zoomWrp.querySelector(".beae-gallery-zoom"), zoomContent = zoomWrp.querySelector(".beae-gallery-zoom-content"), paginationPer = zoomWrp.querySelector(".beae-gallery-zoom-pagination .pagination_item.per"), paginationPrev = zoomWrp.querySelector(".pagination_item.prev"), paginationNext = zoomWrp.querySelector(".pagination_item.next"), zoomItems = zoomWrp.querySelectorAll(".beae-gallery-zoom-item"), zoomControls = zoomWrp.querySelector(".beae-gallery-zoom-controls");
      let stateActiveSlide = () => {
        let activeSlide = zoomWrp.querySelector(".beae-gallery-zoom-item.active");
        let length = 0;
        Array.from(slides).forEach((x) => {
          if (x.getAttribute("type")?.toLowerCase() == "image") {
            length++;
          }
        });
        if (length < 2) {
          zoomControls.style.display = "none";
        } else {
          zoomControls.style.display = "flex";
        }
        paginationPer.textContent = `${Array.from(zoomWrp.querySelectorAll(".beae-gallery-zoom-item")).indexOf(activeSlide) + 1} / ${length}`;
      };
      stateActiveSlide();
      closeBtn.addEventListener("click", (e2) => {
        zoomMain.classList.remove("opened");
      });
      zoomWrp.querySelectorAll(".beae-gallery-zoom-item img").forEach((img) => {
        img.addEventListener("mousemove", (e2) => {
          if (!img.parentNode.classList.contains("beae-gallery-zoom-more")) {
            img.parentNode.classList.add("beae-gallery-zoom-more");
            img.style.cursor = "zoom-in";
            img.addEventListener("click", (e3) => {
              if (img.style.objectFit === "cover") {
                img.style.objectFit = "contain";
                e3.target.style.transition = "";
                img.style.cursor = "zoom-in";
                img.style.objectPosition = "";
              } else {
                img.style.objectFit = "cover";
                img.style.cursor = "zoom-out";
                img.style.objectPosition = 100 * (e3.clientX / img.offsetWidth) + "% " + 100 * ((e3.clientY - img.offsetTop) / img.offsetHeight) + "%";
              }
            });
          } else if (img.parentNode.classList.contains("beae-gallery-zoom-more")) {
            if (img.style.objectFit === "cover") {
              img.style.objectPosition = 100 * (e2.clientX / img.offsetWidth) + "% " + 100 * ((e2.clientY - img.offsetTop) / img.offsetHeight) + "%";
            } else if (img.style.objectPosition) {
              img.style.objectPosition = "";
            }
          }
        });
      });
      zoomMain.addEventListener("transitionend", (e2) => {
        if (e2.propertyName !== "opacity") {
          return;
        }
        if (zoomMain.classList.contains("opened")) {
          closeBtn.style.opacity = 1;
          zoomWrp.querySelectorAll(".beae-gallery-zoom-item img").forEach((img) => {
            img.removeAttribute("srcset");
            img.removeAttribute("sizes");
          });
          zoomWrp.querySelector(".beae-gallery-zoom-item.active").style.order = "";
          zoomContent.scrollTo({ left: zoomWrp.querySelector(".beae-gallery-zoom-item.active").offsetLeft });
        } else {
          zoomWrp.remove();
          document.body.style.overflow = "";
        }
      });
      let unboundTimer = 0;
      zoomContent.addEventListener("scroll", (e2) => {
        clearTimeout(unboundTimer);
        unboundTimer = setTimeout(() => {
          zoomItems.forEach((slide) => {
            if (Math.abs(e2.target.scrollLeft - slide.offsetLeft) < 2) {
              slide.classList.add("active");
              stateActiveSlide();
            } else {
              slide.classList.remove("active");
            }
          });
        }, 250);
      });
      paginationPrev.addEventListener("click", () => {
        let activeSlide = zoomWrp.querySelector(".beae-gallery-zoom-item.active");
        if (activeSlide.previousElementSibling) {
          activeSlide.previousElementSibling.classList.add("active");
        } else if (zoomItems[zoomItems.length - 1] && zoomItems.length > 1) {
          zoomItems[zoomItems.length - 1].classList.add("active");
        } else {
          return;
        }
        activeSlide.classList.remove("active");
        zoomContent.scrollTo({ behavior: "smooth", left: zoomWrp.querySelector(".beae-gallery-zoom-item.active").offsetLeft });
        stateActiveSlide();
      });
      paginationNext.addEventListener("click", () => {
        let activeSlide = zoomWrp.querySelector(".beae-gallery-zoom-item.active");
        if (activeSlide && activeSlide.nextElementSibling) {
          activeSlide.nextElementSibling.classList.add("active");
        } else if (zoomItems[0] && zoomItems.length > 1) {
          zoomItems[0].classList.add("active");
        } else {
          return;
        }
        activeSlide.classList.remove("active");
        zoomContent.scrollTo({ behavior: "smooth", left: zoomWrp.querySelector(".beae-gallery-zoom-item.active").offsetLeft });
        stateActiveSlide();
      });
      setTimeout(() => {
        zoomMain.classList.add("opened");
      }, 10);
    }));
  }, 1e3); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ns1sv0d4: ', ex)
      };
    

      try {
        let argid = 'beae-ns1sv0d4section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ns1sv0d4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ns1sv0d4');
        args.el = args.els[0];
        ((data) => { if (window.BeaeSlider && !data.noRunJs) {
            window.BeaeSlider(data);
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ns1sv0d4: ', ex)
      };
    

      try {
        let argid = 'beae-6f7w9mc3block-description',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6f7w9mc3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6f7w9mc3');
        args.el = args.els[0];
        ((data) => { if (data.hasDescription == "false") {
            if (data.mode.value == "live") {
              data.el.style.display = "none";
            }
            return;
          }
          if (window.isPreviewTemplate) {
            const section2 = data.el.closest("section.beae-section");
            const idSection = section2?.getAttribute("data-sectionid");
            if (idSection) {
              const productWrp = section2.querySelector('script[data-id="Product-json-' + idSection + '"]') || section2.querySelector("#Product-json-" + idSection);
              const product = JSON.parse(
                productWrp?.innerHTML ? productWrp?.innerHTML : "{}"
              );
              if (product && !product.description) {
                data.el.style.display = "none";
              }
            }
          }
          const content = data.el.querySelector(".beae-des-content");
          if (content) {
            if (data.type == "collapsible_tab") {
              const accordion = data.el.querySelector(".beae-des-accordion");
              if (accordion && content) {
                accordion.addEventListener("click", () => {
                  if (content) {
                    if (accordion.classList.contains("active")) {
                      accordion.classList.remove("active");
                      content.style.maxHeight = "0";
                    } else {
                      accordion.classList.add("active");
                      content.style.maxHeight = content.scrollHeight + "px";
                    }
                  }
                });
                if (data.active) {
                  accordion.click();
                }
              }
            } else if (data.type == "show_with_popup") {
              const header = data.el.querySelector(".beae-des-popup > span");
              const buttonLightbox = data.el.querySelector(".beae-des-popup");
              if (buttonLightbox && content) {
                const section = data.el.closest("section.beae-section");
                let sectionId = "";
                if (section) {
                  sectionId = section.getAttribute("data-sectionid");
                }
                let extOptions = {};
                if (data.extendOptions) {
                  try {
                    eval(`extOptions = ` + data.extendOptions);
                  } catch (e) {
                    extOptions = {};
                    console.error(e);
                  }
                }
                buttonLightbox.addEventListener("click", () => {
                  window.BeaePopupLibrary.createPopup(
                    '<h3 class="beae-popup__content-title">' + header.innerHTML + '</h3><div class="beae-popup__content-body">' + content.innerHTML + "</div>",
                    {
                      layout: extOptions.layout ? extOptions.layout : "right",
                      width: extOptions.width ? extOptions.width : "400px",
                      layoutMobile: extOptions.layoutMobile ? extOptions.layoutMobile : "bottom",
                      sectionId
                    }
                  );
                });
              }
            } else if (data.type == "less_more") {
              const btn = data.el.querySelector(".btn-action-les-more");
              const wrp = data.el.querySelector(".beae-less-more");
              const height = wrp.getAttribute("data-height");
              if (wrp) {
                wrp.style.height = height;
              }
              if (btn && wrp) {
                btn.addEventListener("click", () => {
                  const type = btn.getAttribute("data-type");
                  if (type == "more") {
                    wrp.classList.remove("beae-show-more");
                    wrp.style.height = height;
                    btn.setAttribute("data-type", "less");
                    btn.innerHTML = btn.getAttribute("data-show-more-text");
                  } else {
                    wrp.classList.add("beae-show-more");
                    wrp.style.height = wrp.scrollHeight + "px";
                    setTimeout(() => {
                      wrp.style = {};
                    }, 100);
                    btn.setAttribute("data-type", "more");
                    btn.innerHTML = btn.getAttribute("data-show-less-text");
                  }
                });
                if (data.active) {
                  btn.click();
                }
              }
            }
          } else {
            data.els.forEach((el) => {
              if (!el) {
                return;
              }
              const shortDes = el.querySelector(".beae-x-product-short-des");
              if (shortDes.getAttribute("data-type") == "text" && shortDes.getAttribute("data-show") == "false") {
                const shortDesBefore = shortDes.textContent;
                shortDes.innerHTML = convertStringWithDifferentWordCount(
                  shortDesBefore,
                  data.numberOfWords
                );
              }
            });
          }
          function convertStringWithDifferentWordCount(inputString, newWordCount) {
            const words = inputString.split(" ");
            const slicedWords = words.slice(0, newWordCount);
            if (inputString.split(" ").length > newWordCount) {
              return slicedWords.concat("...").join(" ");
            } else {
              return slicedWords.join(" ");
            }
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6f7w9mc3: ', ex)
      };
    

      try {
        let argid = 'beae-qndgbi9iblock-buy',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qndgbi9i',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qndgbi9i');
        args.el = args.els[0];
        ((data) => { const plus = data.el.querySelector('.beae-quantity-btn[name="plus"]');
          const minus = data.el.querySelector('.beae-quantity-btn[name="minus"]');
          const input = data.el.querySelector(".beae-quantity-input");
          if (plus && minus && input) {
            if (input.value === "") {
              input.value = "1";
            }
            plus.addEventListener("click", function() {
              if (plus.getAttribute("disabled") != "disabled") {
                input.stepUp();
              }
            });
            minus.addEventListener("click", function() {
              if (minus.getAttribute("disabled") != "disabled") {
                input.stepDown();
              }
            });
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qndgbi9i: ', ex)
      };
    

      try {
        let argid = 'beae-u9kfmy9h',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-u9kfmy9h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-u9kfmy9h');
        args.el = args.els[0];
        ((data) => { setTimeout(() => {
            const buyItNowBtn = data.el.querySelector(".shopify-payment-button__button", ``);
            if (buyItNowBtn) {
              buyItNowBtn.classList.add(data.buyItNowType);
            }
          }, 1e3); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-u9kfmy9h: ', ex)
      };
    

      try {
        let argid = 'beae-82xqa3rqblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-82xqa3rq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-82xqa3rq');
        args.el = args.els[0];
        ((data) => { if (data.el) {
            let widthWrapper, autoHover = data.autoHover;
            var btnControl = data.el.querySelector(".beae-img-ratio-control"), image = data.el.querySelector(".beae-img-comp-container"), imageSecond = data.el.querySelector(
              ".beae-img-comp-container--second"
            );
            if (btnControl && imageSecond) {
              let handleComparison = function(btnControl2) {
                let checkHandle = 0, clientX, positionBtn, breakPoint;
                init();
                if (autoHover) {
                  data.el.onmouseover = function($) {
                    handlePosition($);
                  };
                } else {
                  btnControl2.onmousedown = function($) {
                    handlePosition($);
                  };
                }
                data.el.onmouseup = function() {
                  reset();
                };
                btnControl2.ontouchstart = function($) {
                  handlePosition($);
                };
                data.el.ontouchend = function() {
                  reset();
                };
                function init() {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  if (btnControl2.style.left) {
                    positionBtn = parseInt(btnControl2.style.left);
                  }
                }
                function handlePosition(event) {
                  check = false;
                  event.preventDefault();
                  if (event.clientX) {
                    clientX = event.clientX;
                  } else {
                    clientX = event.touches[0].clientX;
                  }
                  checkHandle = 1;
                  data.el.onmousemove = function(e) {
                    handleBreakpoint(e);
                  };
                  data.el.ontouchmove = function(e) {
                    handleBreakpoint(e);
                  };
                }
                function reset() {
                  checkHandle = 0;
                  isNaN(breakPoint) || (positionBtn = breakPoint);
                  check = true;
                }
                function handleBreakpoint(event) {
                  if (checkHandle == 0) {
                    return false;
                  }
                  if (autoHover && !(event.target == imageSecond || event.target == data.el.querySelector(".beae-image-secondary"))) {
                    return false;
                  }
                  breakPoint = getBreakPoint(event);
                  if (breakPoint < 0) {
                    breakPoint = 0;
                  }
                  if (breakPoint > 100) {
                    breakPoint = 100;
                  }
                  handleSlide(breakPoint);
                }
                function getBreakPoint(event) {
                  event = event.changedTouches ? event.changedTouches[0] : event;
                  let rs;
                  if (autoHover) {
                    rs = Math.round(event.offsetX * 100 / widthWrapper);
                  } else {
                    rs = Math.round(
                      positionBtn - (clientX - event.pageX) * 100 / widthWrapper
                    );
                  }
                  return rs;
                }
                function handleSlide(val) {
                  btnControl2.style.left = val + "%";
                  imageSecond.style.clipPath = `polygon(${val}% 0%, ${val}% 100%, 100% 100%, 100% 0)`;
                  image.style.clipPath = `polygon(0% 100%, 0% 0%, ${val}% 0%, ${val}% 100%)`;
                }
              };
              if (btnControl && imageSecond) {
                handleComparison(btnControl);
              }
              window.addEventListener("resize", function() {
                if (btnControl && imageSecond) {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  handleComparison(btnControl);
                }
              });
            }
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-82xqa3rq: ', ex)
      };
    

      try {
        let argid = 'beae-5bp6xxx8section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5bp6xxx8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5bp6xxx8');
        args.el = args.els[0];
        ((data) => { data.el.querySelector(".beae-grid-system")?.addEventListener("scroll", (e) => {
    let el = e.target;
    if (!el.classList.contains("beae-grid-carousel")) {
      return;
    }
    let activePage = Math.round((el.scrollLeft + el.querySelector(".beae-grid-carousel__snaps").offsetLeft) / (el.offsetWidth * 0.8)) + 1;
    data.el.querySelector(".beae-grid-carousel__pagination div.active")?.classList.remove("active");
    data.el.querySelector('.beae-grid-carousel__pagination div[data-index="' + activePage + '"]')?.classList.add("active");
  });
  if (data.mode.value == "live") {
    const videoContainer = data.el.querySelector('.beae-section-background-video[data-device="desktop"]');
    const videoMobileContainer = data.el.querySelector('.beae-section-background-video[data-device="mobile"]');
    const initVideoBackground = [];
    if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
      if (window.innerWidth >= 768) {
        if (videoContainer) {
          let options = {};
          if (data.optionsVideo) {
            try {
              eval(`options = ` + data.optionsVideo);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoContainer);
          if (rs) {
            videoContainer.innerHTML = rs.html;
            initVideoBackground.push("desktop");
          }
        }
      } else {
        if (videoMobileContainer) {
          let options = {};
          if (data.optionsVideoMobile) {
            try {
              eval(`options = ` + data.optionsVideoMobile);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoMobileContainer);
          if (rs) {
            videoMobileContainer.innerHTML = rs.html;
            initVideoBackground.push("mobile");
          }
        }
      }
    }
    if (videoContainer || videoMobileContainer) {
      window.addEventListener("resize", () => {
        if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
          if (!initVideoBackground.includes("desktop") && window.innerWidth >= 768 && videoContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo, videoContainer);
            if (rs2) {
              videoContainer.innerHTML = rs2.html;
              initVideoBackground.push("desktop");
            }
          }
          if (!initVideoBackground.includes("mobile") && window.innerWidth < 768 && videoMobileContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile, videoMobileContainer);
            if (rs2) {
              videoMobileContainer.innerHTML = rs2.html;
              initVideoBackground.push("mobile");
            }
          }
        }
      });
    }
  }
  data.el.querySelectorAll(".beae-text-highlight").forEach((element) => {
    let observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll("path, line").forEach((path) => {
            path.style.strokeDasharray = parseFloat(path.getAttribute("data-dash-ratio") * entry.target.offsetWidth * 2) + "px, 999999px";
          });
          observer2.unobserve(entry.target);
        }
      });
    }, { root: document, rootMargin: "0px 0px -40%" });
    observer.observe(element);
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5bp6xxx8: ', ex)
      };
    

      try {
        let argid = 'beae-isw9q60nbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-isw9q60n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-isw9q60n');
        args.el = args.els[0];
        ((data) => { let buttonElm = data.el.querySelector("a.beae-block-info-wrp--link");
          buttonElm && buttonElm.addEventListener("click", (e) => {
            let extOptions = {};
            if (data.extendOptions) {
              try {
                eval(`extOptions = ` + data.extendOptions);
              } catch (e2) {
                extOptions = {};
                console.error(e2);
              }
            }
            if (data.mode.value === "builder") {
              e.preventDefault();
              return false;
            }
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let findTarget = document.querySelector(
                selector + "," + selector.replace("#", ".")
              );
              if (findTarget) {
                findTarget.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center"
                });
                e.preventDefault();
                return false;
              }
            }
            if (data.type === "popup") {
              const loading = window.createLoading(e.currentTarget);
              window.BeaePopupLibrary.lightbox({
                id: data.id,
                url: (data?.url ?? "").replace("/popup/", "/?view=beae-"),
                ...extOptions
              }).then(() => {
                loading.remove();
              });
              e.preventDefault();
              return false;
            } else if (data.type === "pages" && data.lightbox) {
              window.BeaePopupLibrary.createPopup(
                data.pageContent.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'"),
                {
                  id: data.id,
                  ...extOptions
                }
              );
              e.preventDefault();
              return false;
            }
          });
          if (data.type === "popup" && data.lightbox) {
            let observer = new IntersectionObserver((entries, observer2) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer2.unobserve(entry.target);
                  entry.target.click();
                }
              });
            });
            observer.observe(buttonElm);
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-isw9q60n: ', ex)
      };
    

      try {
        let argid = 'beae-jeydprejbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jeydprej',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jeydprej');
        args.el = args.els[0];
        ((data) => { let buttonElm = data.el.querySelector("a.beae-block-info-wrp--link");
          buttonElm && buttonElm.addEventListener("click", (e) => {
            let extOptions = {};
            if (data.extendOptions) {
              try {
                eval(`extOptions = ` + data.extendOptions);
              } catch (e2) {
                extOptions = {};
                console.error(e2);
              }
            }
            if (data.mode.value === "builder") {
              e.preventDefault();
              return false;
            }
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let findTarget = document.querySelector(
                selector + "," + selector.replace("#", ".")
              );
              if (findTarget) {
                findTarget.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center"
                });
                e.preventDefault();
                return false;
              }
            }
            if (data.type === "popup") {
              const loading = window.createLoading(e.currentTarget);
              window.BeaePopupLibrary.lightbox({
                id: data.id,
                url: (data?.url ?? "").replace("/popup/", "/?view=beae-"),
                ...extOptions
              }).then(() => {
                loading.remove();
              });
              e.preventDefault();
              return false;
            } else if (data.type === "pages" && data.lightbox) {
              window.BeaePopupLibrary.createPopup(
                data.pageContent.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'"),
                {
                  id: data.id,
                  ...extOptions
                }
              );
              e.preventDefault();
              return false;
            }
          });
          if (data.type === "popup" && data.lightbox) {
            let observer = new IntersectionObserver((entries, observer2) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer2.unobserve(entry.target);
                  entry.target.click();
                }
              });
            });
            observer.observe(buttonElm);
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jeydprej: ', ex)
      };
    

      try {
        let argid = 'beae-riwil9r8button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-riwil9r8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-riwil9r8');
        args.el = args.els[0];
        ((data) => { let buttonElm = data.el.querySelector("a.beae-block-info-wrp--link");
          buttonElm && buttonElm.addEventListener("click", (e) => {
            let extOptions = {};
            if (data.extendOptions) {
              try {
                eval(`extOptions = ` + data.extendOptions);
              } catch (e2) {
                extOptions = {};
                console.error(e2);
              }
            }
            if (data.mode.value === "builder") {
              e.preventDefault();
              return false;
            }
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let findTarget = document.querySelector(
                selector + "," + selector.replace("#", ".")
              );
              if (findTarget) {
                findTarget.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center"
                });
                e.preventDefault();
                return false;
              }
            }
            if (data.type === "popup") {
              const loading = window.createLoading(e.currentTarget);
              window.BeaePopupLibrary.lightbox({
                id: data.id,
                url: (data?.url ?? "").replace("/popup/", "/?view=beae-"),
                ...extOptions
              }).then(() => {
                loading.remove();
              });
              e.preventDefault();
              return false;
            } else if (data.type === "pages" && data.lightbox) {
              window.BeaePopupLibrary.createPopup(
                data.pageContent.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'"),
                {
                  id: data.id,
                  ...extOptions
                }
              );
              e.preventDefault();
              return false;
            }
          });
          if (data.type === "popup" && data.lightbox) {
            let observer = new IntersectionObserver((entries, observer2) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer2.unobserve(entry.target);
                  entry.target.click();
                }
              });
            });
            observer.observe(buttonElm);
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-riwil9r8: ', ex)
      };
    

      try {
        let argid = 'beae-6myjko1pbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6myjko1p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6myjko1p');
        args.el = args.els[0];
        ((data) => { let buttonElm = data.el.querySelector("a.beae-block-info-wrp--link");
          buttonElm && buttonElm.addEventListener("click", (e) => {
            let extOptions = {};
            if (data.extendOptions) {
              try {
                eval(`extOptions = ` + data.extendOptions);
              } catch (e2) {
                extOptions = {};
                console.error(e2);
              }
            }
            if (data.mode.value === "builder") {
              e.preventDefault();
              return false;
            }
            let selector = e.currentTarget.getAttribute("href");
            if (selector.indexOf("#") === 0 && selector !== "#") {
              let findTarget = document.querySelector(
                selector + "," + selector.replace("#", ".")
              );
              if (findTarget) {
                findTarget.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center"
                });
                e.preventDefault();
                return false;
              }
            }
            if (data.type === "popup") {
              const loading = window.createLoading(e.currentTarget);
              window.BeaePopupLibrary.lightbox({
                id: data.id,
                url: (data?.url ?? "").replace("/popup/", "/?view=beae-"),
                ...extOptions
              }).then(() => {
                loading.remove();
              });
              e.preventDefault();
              return false;
            } else if (data.type === "pages" && data.lightbox) {
              window.BeaePopupLibrary.createPopup(
                data.pageContent.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'"),
                {
                  id: data.id,
                  ...extOptions
                }
              );
              e.preventDefault();
              return false;
            }
          });
          if (data.type === "popup" && data.lightbox) {
            let observer = new IntersectionObserver((entries, observer2) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer2.unobserve(entry.target);
                  entry.target.click();
                }
              });
            });
            observer.observe(buttonElm);
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6myjko1p: ', ex)
      };
    

      try {
        let argid = 'beae-fyxkth3ysection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fyxkth3y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fyxkth3y');
        args.el = args.els[0];
        ((data) => { data.el.querySelector(".beae-grid-system")?.addEventListener("scroll", (e) => {
    let el = e.target;
    if (!el.classList.contains("beae-grid-carousel")) {
      return;
    }
    let activePage = Math.round((el.scrollLeft + el.querySelector(".beae-grid-carousel__snaps").offsetLeft) / (el.offsetWidth * 0.8)) + 1;
    data.el.querySelector(".beae-grid-carousel__pagination div.active")?.classList.remove("active");
    data.el.querySelector('.beae-grid-carousel__pagination div[data-index="' + activePage + '"]')?.classList.add("active");
  });
  if (data.mode.value == "live") {
    const videoContainer = data.el.querySelector('.beae-section-background-video[data-device="desktop"]');
    const videoMobileContainer = data.el.querySelector('.beae-section-background-video[data-device="mobile"]');
    const initVideoBackground = [];
    if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
      if (window.innerWidth >= 768) {
        if (videoContainer) {
          let options = {};
          if (data.optionsVideo) {
            try {
              eval(`options = ` + data.optionsVideo);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoContainer);
          if (rs) {
            videoContainer.innerHTML = rs.html;
            initVideoBackground.push("desktop");
          }
        }
      } else {
        if (videoMobileContainer) {
          let options = {};
          if (data.optionsVideoMobile) {
            try {
              eval(`options = ` + data.optionsVideoMobile);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoMobileContainer);
          if (rs) {
            videoMobileContainer.innerHTML = rs.html;
            initVideoBackground.push("mobile");
          }
        }
      }
    }
    if (videoContainer || videoMobileContainer) {
      window.addEventListener("resize", () => {
        if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
          if (!initVideoBackground.includes("desktop") && window.innerWidth >= 768 && videoContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo, videoContainer);
            if (rs2) {
              videoContainer.innerHTML = rs2.html;
              initVideoBackground.push("desktop");
            }
          }
          if (!initVideoBackground.includes("mobile") && window.innerWidth < 768 && videoMobileContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile, videoMobileContainer);
            if (rs2) {
              videoMobileContainer.innerHTML = rs2.html;
              initVideoBackground.push("mobile");
            }
          }
        }
      });
    }
  }
  data.el.querySelectorAll(".beae-text-highlight").forEach((element) => {
    let observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll("path, line").forEach((path) => {
            path.style.strokeDasharray = parseFloat(path.getAttribute("data-dash-ratio") * entry.target.offsetWidth * 2) + "px, 999999px";
          });
          observer2.unobserve(entry.target);
        }
      });
    }, { root: document, rootMargin: "0px 0px -40%" });
    observer.observe(element);
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fyxkth3y: ', ex)
      };
    

      try {
        let argid = 'beae-fyxkth3ysection-featured-collection',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fyxkth3y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fyxkth3y');
        args.el = args.els[0];
        ((data) => { if (window.BeaeSlideshow) {
    window.BeaeSlideshow.init(data);
  } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fyxkth3y: ', ex)
      };
    

      try {
        let argid = 'beae-fyxkth3ysection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-fyxkth3y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-fyxkth3y');
        args.el = args.els[0];
        ((data) => { if (window.BeaeSlider && !data.noRunJs) {
            window.BeaeSlider(data);
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-fyxkth3y: ', ex)
      };
    

      try {
        let argid = 'beae-cr4e56ugblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cr4e56ug',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cr4e56ug');
        args.el = args.els[0];
        ((data) => { if (data.el) {
            let widthWrapper, autoHover = data.autoHover;
            var btnControl = data.el.querySelector(".beae-img-ratio-control"), image = data.el.querySelector(".beae-img-comp-container"), imageSecond = data.el.querySelector(
              ".beae-img-comp-container--second"
            );
            if (btnControl && imageSecond) {
              let handleComparison = function(btnControl2) {
                let checkHandle = 0, clientX, positionBtn, breakPoint;
                init();
                if (autoHover) {
                  data.el.onmouseover = function($) {
                    handlePosition($);
                  };
                } else {
                  btnControl2.onmousedown = function($) {
                    handlePosition($);
                  };
                }
                data.el.onmouseup = function() {
                  reset();
                };
                btnControl2.ontouchstart = function($) {
                  handlePosition($);
                };
                data.el.ontouchend = function() {
                  reset();
                };
                function init() {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  if (btnControl2.style.left) {
                    positionBtn = parseInt(btnControl2.style.left);
                  }
                }
                function handlePosition(event) {
                  check = false;
                  event.preventDefault();
                  if (event.clientX) {
                    clientX = event.clientX;
                  } else {
                    clientX = event.touches[0].clientX;
                  }
                  checkHandle = 1;
                  data.el.onmousemove = function(e) {
                    handleBreakpoint(e);
                  };
                  data.el.ontouchmove = function(e) {
                    handleBreakpoint(e);
                  };
                }
                function reset() {
                  checkHandle = 0;
                  isNaN(breakPoint) || (positionBtn = breakPoint);
                  check = true;
                }
                function handleBreakpoint(event) {
                  if (checkHandle == 0) {
                    return false;
                  }
                  if (autoHover && !(event.target == imageSecond || event.target == data.el.querySelector(".beae-image-secondary"))) {
                    return false;
                  }
                  breakPoint = getBreakPoint(event);
                  if (breakPoint < 0) {
                    breakPoint = 0;
                  }
                  if (breakPoint > 100) {
                    breakPoint = 100;
                  }
                  handleSlide(breakPoint);
                }
                function getBreakPoint(event) {
                  event = event.changedTouches ? event.changedTouches[0] : event;
                  let rs;
                  if (autoHover) {
                    rs = Math.round(event.offsetX * 100 / widthWrapper);
                  } else {
                    rs = Math.round(
                      positionBtn - (clientX - event.pageX) * 100 / widthWrapper
                    );
                  }
                  return rs;
                }
                function handleSlide(val) {
                  btnControl2.style.left = val + "%";
                  imageSecond.style.clipPath = `polygon(${val}% 0%, ${val}% 100%, 100% 100%, 100% 0)`;
                  image.style.clipPath = `polygon(0% 100%, 0% 0%, ${val}% 0%, ${val}% 100%)`;
                }
              };
              if (btnControl && imageSecond) {
                handleComparison(btnControl);
              }
              window.addEventListener("resize", function() {
                if (btnControl && imageSecond) {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  handleComparison(btnControl);
                }
              });
            }
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cr4e56ug: ', ex)
      };
    

      try {
        let argid = 'beae-eabej892section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eabej892',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eabej892');
        args.el = args.els[0];
        ((data) => { data.el.querySelector(".beae-grid-system")?.addEventListener("scroll", (e) => {
    let el = e.target;
    if (!el.classList.contains("beae-grid-carousel")) {
      return;
    }
    let activePage = Math.round((el.scrollLeft + el.querySelector(".beae-grid-carousel__snaps").offsetLeft) / (el.offsetWidth * 0.8)) + 1;
    data.el.querySelector(".beae-grid-carousel__pagination div.active")?.classList.remove("active");
    data.el.querySelector('.beae-grid-carousel__pagination div[data-index="' + activePage + '"]')?.classList.add("active");
  });
  if (data.mode.value == "live") {
    const videoContainer = data.el.querySelector('.beae-section-background-video[data-device="desktop"]');
    const videoMobileContainer = data.el.querySelector('.beae-section-background-video[data-device="mobile"]');
    const initVideoBackground = [];
    if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
      if (window.innerWidth >= 768) {
        if (videoContainer) {
          let options = {};
          if (data.optionsVideo) {
            try {
              eval(`options = ` + data.optionsVideo);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoContainer);
          if (rs) {
            videoContainer.innerHTML = rs.html;
            initVideoBackground.push("desktop");
          }
        }
      } else {
        if (videoMobileContainer) {
          let options = {};
          if (data.optionsVideoMobile) {
            try {
              eval(`options = ` + data.optionsVideoMobile);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoMobileContainer);
          if (rs) {
            videoMobileContainer.innerHTML = rs.html;
            initVideoBackground.push("mobile");
          }
        }
      }
    }
    if (videoContainer || videoMobileContainer) {
      window.addEventListener("resize", () => {
        if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
          if (!initVideoBackground.includes("desktop") && window.innerWidth >= 768 && videoContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo, videoContainer);
            if (rs2) {
              videoContainer.innerHTML = rs2.html;
              initVideoBackground.push("desktop");
            }
          }
          if (!initVideoBackground.includes("mobile") && window.innerWidth < 768 && videoMobileContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile, videoMobileContainer);
            if (rs2) {
              videoMobileContainer.innerHTML = rs2.html;
              initVideoBackground.push("mobile");
            }
          }
        }
      });
    }
  }
  data.el.querySelectorAll(".beae-text-highlight").forEach((element) => {
    let observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll("path, line").forEach((path) => {
            path.style.strokeDasharray = parseFloat(path.getAttribute("data-dash-ratio") * entry.target.offsetWidth * 2) + "px, 999999px";
          });
          observer2.unobserve(entry.target);
        }
      });
    }, { root: document, rootMargin: "0px 0px -40%" });
    observer.observe(element);
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eabej892: ', ex)
      };
    

      try {
        let argid = 'beae-eabej892section-featured-collection',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eabej892',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eabej892');
        args.el = args.els[0];
        ((data) => { if (!window.BeaeMoneyFormat) {
    window.BeaeMoneyFormat = data.el.querySelector(".beae-money-format")?.innerHTML;
  }
  let navs = data.el.querySelectorAll(
    ".beae-featuted-collection-nav"
  );
  const tabcontent = data.el.querySelectorAll(
    ".beae-feature-collection-tab-content"
  );
  const inited = data.el.querySelector(
    ".beae-featuted-collection-nav.nav-active"
  );
  const isPreview = data.el.closest(".beae-body--preview");
  navs.forEach((nav, index) => {
    if (data.mode.value == "live" && !inited) {
      if (index === 0) {
        nav.classList.add("nav-active");
        if (tabcontent[index]) {
          tabcontent[index].style.display = "block";
          tabcontent[index].setAttribute("data-active", "true");
        }
      } else {
        nav.classList.remove("nav-active");
        if (tabcontent[index]) {
          tabcontent[index].style.display = "none";
          tabcontent[index].setAttribute("data-active", "false");
        }
      }
    }
    let isProgress = false;
    nav.addEventListener("click", () => {
      if (isProgress)
        return;
      isProgress = true;
      navs.forEach((nav2) => {
        nav2.classList.remove("nav-active");
      });
      nav.classList.add("nav-active");
      const handle = nav.getAttribute("data-handle");
      const viewAllButtons = data.el.querySelectorAll(".viewall-link");
      viewAllButtons && viewAllButtons.forEach((button) => {
        button.setAttribute("href", `/collections/${handle}`);
      });
      const target = data.el.querySelector(
        `.beae-feature-collection-tab-content[data-handle="${handle}"]`
      );
      const activeTabcontent = data.el.querySelector(
        '.beae-feature-collection-tab-content[data-active="true"]'
      );
      if (data.el.querySelector(".beae-feature-collection-tab-content.content-active") !== null) {
        data.el.querySelector(".beae-feature-collection-tab-content.content-active").classList.remove("content-active");
      }
      if (activeTabcontent) {
        activeTabcontent.setAttribute("data-active", "false");
        const time = getDuration(activeTabcontent);
        setTimeout(() => {
          activeTabcontent.style.display = "none";
          target && (target.style.display = "block");
          setTimeout(() => {
            target && target.setAttribute("data-active", "true");
            isProgress = false;
          }, 50);
        }, time);
      } else {
        target && (target.style.display = "block");
        setTimeout(() => {
          target && target.setAttribute("data-active", "true");
          isProgress = false;
        }, 50);
      }
    });
  });
  function getDuration(element) {
    const computedStyle = window.getComputedStyle(element);
    const transitionDuration = computedStyle.getPropertyValue(
      "transition-duration"
    );
    let durationInMilliseconds = parseFloat(transitionDuration) * 1e3;
    if (transitionDuration.includes("s")) {
      durationInMilliseconds = parseFloat(transitionDuration) * 1e3;
    } else {
      durationInMilliseconds = parseFloat(transitionDuration);
    }
    return durationInMilliseconds ? durationInMilliseconds : 0;
  }
  setTimeout(() => {
    if (typeof window.handleSwatchForCardForm == "function") {
      window.handleSwatchForCardForm(data);
    }
  }, 100);
  if (["builder"].includes(data.mode.value) || isPreview) {
    setTimeout(() => {
      if (typeof window.handleEventFormProductCard == "function") {
        window.handleEventFormProductCard();
      }
    }, 100);
  } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eabej892: ', ex)
      };
    

      try {
        let argid = 'beae-eabej892section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eabej892',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eabej892');
        args.el = args.els[0];
        ((data) => { if (window.BeaeSlider && !data.noRunJs) {
            window.BeaeSlider(data);
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eabej892: ', ex)
      };
    

      try {
        let argid = 'beae-ntitzercblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ntitzerc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ntitzerc');
        args.el = args.els[0];
        ((data) => { if (data.el) {
            let widthWrapper, autoHover = data.autoHover;
            var btnControl = data.el.querySelector(".beae-img-ratio-control"), image = data.el.querySelector(".beae-img-comp-container"), imageSecond = data.el.querySelector(
              ".beae-img-comp-container--second"
            );
            if (btnControl && imageSecond) {
              let handleComparison = function(btnControl2) {
                let checkHandle = 0, clientX, positionBtn, breakPoint;
                init();
                if (autoHover) {
                  data.el.onmouseover = function($) {
                    handlePosition($);
                  };
                } else {
                  btnControl2.onmousedown = function($) {
                    handlePosition($);
                  };
                }
                data.el.onmouseup = function() {
                  reset();
                };
                btnControl2.ontouchstart = function($) {
                  handlePosition($);
                };
                data.el.ontouchend = function() {
                  reset();
                };
                function init() {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  if (btnControl2.style.left) {
                    positionBtn = parseInt(btnControl2.style.left);
                  }
                }
                function handlePosition(event) {
                  check = false;
                  event.preventDefault();
                  if (event.clientX) {
                    clientX = event.clientX;
                  } else {
                    clientX = event.touches[0].clientX;
                  }
                  checkHandle = 1;
                  data.el.onmousemove = function(e) {
                    handleBreakpoint(e);
                  };
                  data.el.ontouchmove = function(e) {
                    handleBreakpoint(e);
                  };
                }
                function reset() {
                  checkHandle = 0;
                  isNaN(breakPoint) || (positionBtn = breakPoint);
                  check = true;
                }
                function handleBreakpoint(event) {
                  if (checkHandle == 0) {
                    return false;
                  }
                  if (autoHover && !(event.target == imageSecond || event.target == data.el.querySelector(".beae-image-secondary"))) {
                    return false;
                  }
                  breakPoint = getBreakPoint(event);
                  if (breakPoint < 0) {
                    breakPoint = 0;
                  }
                  if (breakPoint > 100) {
                    breakPoint = 100;
                  }
                  handleSlide(breakPoint);
                }
                function getBreakPoint(event) {
                  event = event.changedTouches ? event.changedTouches[0] : event;
                  let rs;
                  if (autoHover) {
                    rs = Math.round(event.offsetX * 100 / widthWrapper);
                  } else {
                    rs = Math.round(
                      positionBtn - (clientX - event.pageX) * 100 / widthWrapper
                    );
                  }
                  return rs;
                }
                function handleSlide(val) {
                  btnControl2.style.left = val + "%";
                  imageSecond.style.clipPath = `polygon(${val}% 0%, ${val}% 100%, 100% 100%, 100% 0)`;
                  image.style.clipPath = `polygon(0% 100%, 0% 0%, ${val}% 0%, ${val}% 100%)`;
                }
              };
              if (btnControl && imageSecond) {
                handleComparison(btnControl);
              }
              window.addEventListener("resize", function() {
                if (btnControl && imageSecond) {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  handleComparison(btnControl);
                }
              });
            }
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ntitzerc: ', ex)
      };
    

      try {
        let argid = 'beae-lw7aibs5section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lw7aibs5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lw7aibs5');
        args.el = args.els[0];
        ((data) => { data.el.querySelector(".beae-grid-system")?.addEventListener("scroll", (e) => {
    let el = e.target;
    if (!el.classList.contains("beae-grid-carousel")) {
      return;
    }
    let activePage = Math.round((el.scrollLeft + el.querySelector(".beae-grid-carousel__snaps").offsetLeft) / (el.offsetWidth * 0.8)) + 1;
    data.el.querySelector(".beae-grid-carousel__pagination div.active")?.classList.remove("active");
    data.el.querySelector('.beae-grid-carousel__pagination div[data-index="' + activePage + '"]')?.classList.add("active");
  });
  if (data.mode.value == "live") {
    const videoContainer = data.el.querySelector('.beae-section-background-video[data-device="desktop"]');
    const videoMobileContainer = data.el.querySelector('.beae-section-background-video[data-device="mobile"]');
    const initVideoBackground = [];
    if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
      if (window.innerWidth >= 768) {
        if (videoContainer) {
          let options = {};
          if (data.optionsVideo) {
            try {
              eval(`options = ` + data.optionsVideo);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoContainer);
          if (rs) {
            videoContainer.innerHTML = rs.html;
            initVideoBackground.push("desktop");
          }
        }
      } else {
        if (videoMobileContainer) {
          let options = {};
          if (data.optionsVideoMobile) {
            try {
              eval(`options = ` + data.optionsVideoMobile);
            } catch (e) {
              options = {};
              console.error(e);
            }
          }
          const rs = window.BEAEVIDEO.convertBackgroundSection(options, videoMobileContainer);
          if (rs) {
            videoMobileContainer.innerHTML = rs.html;
            initVideoBackground.push("mobile");
          }
        }
      }
    }
    if (videoContainer || videoMobileContainer) {
      window.addEventListener("resize", () => {
        if (window.BEAEVIDEO && window.BEAEVIDEO.convertBackgroundSection) {
          if (!initVideoBackground.includes("desktop") && window.innerWidth >= 768 && videoContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo, videoContainer);
            if (rs2) {
              videoContainer.innerHTML = rs2.html;
              initVideoBackground.push("desktop");
            }
          }
          if (!initVideoBackground.includes("mobile") && window.innerWidth < 768 && videoMobileContainer) {
            const rs2 = window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile, videoMobileContainer);
            if (rs2) {
              videoMobileContainer.innerHTML = rs2.html;
              initVideoBackground.push("mobile");
            }
          }
        }
      });
    }
  }
  data.el.querySelectorAll(".beae-text-highlight").forEach((element) => {
    let observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll("path, line").forEach((path) => {
            path.style.strokeDasharray = parseFloat(path.getAttribute("data-dash-ratio") * entry.target.offsetWidth * 2) + "px, 999999px";
          });
          observer2.unobserve(entry.target);
        }
      });
    }, { root: document, rootMargin: "0px 0px -40%" });
    observer.observe(element);
  }); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lw7aibs5: ', ex)
      };
    

      try {
        let argid = 'beae-ba9m44n2block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ba9m44n2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ba9m44n2');
        args.el = args.els[0];
        ((data) => { if (data.el) {
            let widthWrapper, autoHover = data.autoHover;
            var btnControl = data.el.querySelector(".beae-img-ratio-control"), image = data.el.querySelector(".beae-img-comp-container"), imageSecond = data.el.querySelector(
              ".beae-img-comp-container--second"
            );
            if (btnControl && imageSecond) {
              let handleComparison = function(btnControl2) {
                let checkHandle = 0, clientX, positionBtn, breakPoint;
                init();
                if (autoHover) {
                  data.el.onmouseover = function($) {
                    handlePosition($);
                  };
                } else {
                  btnControl2.onmousedown = function($) {
                    handlePosition($);
                  };
                }
                data.el.onmouseup = function() {
                  reset();
                };
                btnControl2.ontouchstart = function($) {
                  handlePosition($);
                };
                data.el.ontouchend = function() {
                  reset();
                };
                function init() {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  if (btnControl2.style.left) {
                    positionBtn = parseInt(btnControl2.style.left);
                  }
                }
                function handlePosition(event) {
                  check = false;
                  event.preventDefault();
                  if (event.clientX) {
                    clientX = event.clientX;
                  } else {
                    clientX = event.touches[0].clientX;
                  }
                  checkHandle = 1;
                  data.el.onmousemove = function(e) {
                    handleBreakpoint(e);
                  };
                  data.el.ontouchmove = function(e) {
                    handleBreakpoint(e);
                  };
                }
                function reset() {
                  checkHandle = 0;
                  isNaN(breakPoint) || (positionBtn = breakPoint);
                  check = true;
                }
                function handleBreakpoint(event) {
                  if (checkHandle == 0) {
                    return false;
                  }
                  if (autoHover && !(event.target == imageSecond || event.target == data.el.querySelector(".beae-image-secondary"))) {
                    return false;
                  }
                  breakPoint = getBreakPoint(event);
                  if (breakPoint < 0) {
                    breakPoint = 0;
                  }
                  if (breakPoint > 100) {
                    breakPoint = 100;
                  }
                  handleSlide(breakPoint);
                }
                function getBreakPoint(event) {
                  event = event.changedTouches ? event.changedTouches[0] : event;
                  let rs;
                  if (autoHover) {
                    rs = Math.round(event.offsetX * 100 / widthWrapper);
                  } else {
                    rs = Math.round(
                      positionBtn - (clientX - event.pageX) * 100 / widthWrapper
                    );
                  }
                  return rs;
                }
                function handleSlide(val) {
                  btnControl2.style.left = val + "%";
                  imageSecond.style.clipPath = `polygon(${val}% 0%, ${val}% 100%, 100% 100%, 100% 0)`;
                  image.style.clipPath = `polygon(0% 100%, 0% 0%, ${val}% 0%, ${val}% 100%)`;
                }
              };
              if (btnControl && imageSecond) {
                handleComparison(btnControl);
              }
              window.addEventListener("resize", function() {
                if (btnControl && imageSecond) {
                  const imageObserver = new ResizeObserver(() => {
                    window.requestAnimationFrame(() => {
                      widthWrapper = imageSecond.offsetWidth;
                    });
                  });
                  imageObserver.observe(imageSecond);
                  handleComparison(btnControl);
                }
              });
            }
          } })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ba9m44n2: ', ex)
      };
    }; if (window.BEAEBASE) {js_KCG8N694()} else {window.BEAEPAGEJS.push(js_KCG8N694)} })(); 